global.hasAdBlock = false
